import classNames from "classnames";
import { ECustomFormatter } from "motw_core/Enums/ECustomFormatter";
import * as React from "react";
import { IWorkflowNode } from "../../../../../../../../motw_core/Entity/IWorkflowNode";
import { NameWithoutURLs, ShouldshowHoverStyle } from "./ChildNodeName";
import * as styles from "./ChildNodeName.css";
import { GetCustomFormattedText } from "./CustomFormatted/GetCustomFormattedText";
import { LimitNameToOneLine } from "./LimitNameToOneLine";

export function ChildNodeNameText({
    node,
    name,
    scrambledNode,
    limitNameDisplayLength,
    rootNode,
}: {
    node: IWorkflowNode;
    name: string;
    scrambledNode: IWorkflowNode;
    limitNameDisplayLength?: boolean;
    rootNode: IWorkflowNode;
}) {
    const nameWithoutURLs = NameWithoutURLs(name);

    const textToRender = GetTextToDisplay(
        nameWithoutURLs,
        limitNameDisplayLength,
        node.is_encrypted,
        rootNode.options?.customFormatter
    );

    if (scrambledNode.name === name) {
        return (
            <span className={classNames([styles.text], [styles.node])}>
                {textToRender}
            </span>
        );
    }

    return (
        <span
            className={classNames([styles.text], {
                [styles.node]: ShouldshowHoverStyle(node),
            })}
        >
            {textToRender}
        </span>
    );
}

function GetTextToDisplay(
    textToDisplay: string,
    limitNameDisplayLength: boolean | undefined,
    isEncrypted: boolean,
    customFormatter: ECustomFormatter | undefined
) {
    if (isEncrypted) {
        return <span>"x-x"</span>;
    }

    if (customFormatter !== undefined) {
        var result = GetCustomFormattedText(textToDisplay, customFormatter);
        return result;
    }

    textToDisplay = limitNameDisplayLength
        ? LimitNameToOneLine(textToDisplay)
        : textToDisplay;

    return <span>{textToDisplay}</span>;
}
